<template>
    <AuthenticationBasic :title="$t('authentication.resetPassword')">
        <v-form ref="form" v-model="valid" @submit.prevent="forgotPassword">
            <v-text-field
                    v-model="email"
                    :label="$t('authentication.email')"
                    :rules="[$validations.required, $validations.email]"
                    class="mb-2"
                    required
            ></v-text-field>
            <v-btn
                    :loading="loading"
                    block
                    class="elevation-5 mt-5 accentText--text"
                    color="accent"
                    large
                    @click="forgotPassword">
                {{ $t('authentication.resetPassword') }}
            </v-btn>
            <v-btn
                    block
                    class="mt-5 elevation-5  secondary--text"
                    color="primary"
                    large
                    @click="$router.back()">
                {{ $t('cancel') }}
            </v-btn>
        </v-form>
    </AuthenticationBasic>
</template>

<script>
import AuthenticationBasic from "@/components/Authentication/AuthenticationBasic";


export default {
  name: "ForgotPassword",
  components: {AuthenticationBasic},
  data() {
    return {
      loading: false,
      valid: false,
      sentMail: false,
      email: ''
    };
  },
  methods: {
    forgotPassword() {
      this.$refs.form.validate();
      if (!this.valid) {
        return;
      }
      const url = this.$store.getters.getUrl('requestPasswordReset');

      this.loading = true;
      this.axios.post(url, this.email).then(() => {
        this.$router.push({name: 'login'});
        this.$store.dispatch('addNotification', {
          type: 'success',
          message: this.$t('success.passwordResetSent')
        });
      }).finally(() => {
        this.loading = false;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "forgot-password";
</style>